import React, { useState, useEffect } from "react";
import axios from "axios";
import {
  AESEncryption,
  ApiResDecrypt,
  checkEmpty,
  getTabStatus,
  goToClientDashboard,
  noDataFound,
} from "../../CommonMethhods/CommonMethods";
import {
  numDifferentiation,
  // numDifferentiationWithoutSymbol,
} from "../../CommonMethhods/CovertRupees";
import Loader from "../Common/Loader";
import { Modal } from "react-bootstrap";
import { Constants } from "../../CommonMethhods/Constants";
import SmallLoader from "../Common/smallLoader";
import LoaderForSearch from "../Common/LoaderForSearch";
import { toast } from "react-toastify";

function TopActiveClientTable(props) {
  const storeToken = localStorage.getItem("ssoToken");
  const [activeClientInfo, setActiveClientInfo] = useState([]);
  const [loader, setLoader] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [scrollLoader, setScrollLoader] = useState(false);
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(5);
  const [fileType, setFileType] = useState("grid");
  const [smallLoaderExcel, setSmallLoaderExcel] = useState(false);
  const [smallLoaderPdf, setSmallLoaderPdf] = useState(false);
  const [serverError, setServerError] = useState("");
  const [count, setCount] = useState();

  const getActiveClientTableInfo = async () => {
    if (fileType == "excel") {
      setSmallLoaderExcel(true);
      setSmallLoaderPdf(false);
      setLoader(false);
    } else if (fileType == "pdf") {
      setSmallLoaderExcel(false);
      setSmallLoaderPdf(true);
      setLoader(false);
    } else {
      setSmallLoaderExcel(false);
      setSmallLoaderPdf(false);
    }
    let payloadValue = {
      pageSize: pageSize,
      pageNo: page,
      fileType: fileType,
    };
    let encPayload = AESEncryption(payloadValue);
    try {
      const getActiveInFo = await axios.post(
        props.getActiveClientInfo,

        `"${encPayload}"`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${storeToken}`,
            reserv: 1,
          },
        }
      );
      let response = ApiResDecrypt(getActiveInFo?.data);
      const res = response.data;
      setCount(res.totalClients);
      if (res) {
        // setActiveClientInfo(res.eq || res.clients);
        // setActive(res.eq || res.clients)
        if (showModal == true) {
          if (fileType == "grid") {
            setActiveClientInfo((prev) => {
              return [...prev, ...res.clients];
            });
          } else if (fileType == "pdf") {
            window.open(res, "_blank", "noopener,noreferrer");
          } else {
            window.open(res, "_blank", "noopener,noreferrer");
          }
        } else {
          // setActive(res.eq || res.clients)
          setActiveClientInfo(res.eq || res.clients);
          // if (fileType == "excel") {
          //   toast.error("No Data Available");
          // } else if (fileType == "pdf") {
          //   toast.error("No Data Available");
          // }
        }
      }
      setLoader(false);
      setSmallLoaderExcel(false);
      setScrollLoader(false);
      setSmallLoaderPdf(false);
    } catch (error) {
      console.log(error);
      setLoader(false);
      setSmallLoaderExcel(false);
      setScrollLoader(false);
      setSmallLoaderPdf(false);
      setServerError("Something went wrong, Please try again later.");
      if (fileType == "excel") {
        toast.error("Something went wrong, Please try again later.");
      }
      if (fileType == "pdf") {
        toast.error("Something went wrong, Please try again later.");
      }
    }
  };

  const handleScroll = (e) => {
    setFileType("grid");
    if (showModal == true) {
      setPageSize(5);
      const a = document.querySelector("#abcd1");
      if (a.scrollTop + a.offsetHeight + 1 >= a.scrollHeight) {
        if (count <= pageSize * page) {
          setScrollLoader(false);
          return;
        }
        setPage((prev) => prev + 1);
        setScrollLoader(true);
      }
    } else {
      setPage(1);
    }
  };

  const handleViewClick = () => {
    setShowModal(true);
    getActiveClientTableInfo();
  };
  useEffect(() => {
    getActiveClientTableInfo();
  }, [page, fileType]);

  const onHide = () => {
    setShowModal(false);
    setPage(1);
    setPageSize(5);
    setFileType("grid");
    // setActiveClientInfo(active)
  };

  const handleFileType = (e) => {
    if (e.target.value) {
      setFileType(e.target.value);
      setPageSize(-1);
    }
  };
  

  const showActiveData = (activeClientInfo) => {
    return (
      activeClientInfo &&
      activeClientInfo.map((info, key) => {
        return (
          <tr key={key}>
            <td>
              <a
                href="/client-dashboard"
                onClick={() => {
                  goToClientDashboard(info.clientCode, "");
                  getTabStatus("")
                  // Navigate("/client-dashboard");
                }}
              >
                {checkEmpty(info.clientCode) ? "-" : info.clientCode}
              </a>
            </td>
            <td>{checkEmpty(info.clientName) ? "-" : info.clientName}</td>
            {/* <td>{checkEmpty(info.margin) ? "-" : info.margin}</td> */}
            <td>
              {checkEmpty(info.ytdBrokerage)
                ? "-"
                : numDifferentiation(info.ytdBrokerage)}
            </td>

            {/* <td>{checkEmpty(info.pastAvg) ? "-" : info.pastAvg}</td> */}
            {/* <td>
              <span
                className={
                  info.pnl == 0
                    ? "text-muted"
                    : info.pnl < 0
                    ? "red-txt"
                    : "green-txt"
                }
              >
                {checkEmpty(info.pnl) ? "-" : numDifferentiation(info.pnl)}
              </span>
            </td> */}
            <td>
              {checkEmpty(info?.prevYrBrokerage)
                ? "-"
                : numDifferentiation(info?.prevYrBrokerage)}
            </td>
            {/* <td>
              {checkEmpty(info.lifetimeBrokerage)
                ? "-"
                : numDifferentiation(info.lifetimeBrokerage)}
            </td> */}
          </tr>
        );
      })
    );
  };

  const showModalActiveData = (activeClientInfo) => {
    return (
      activeClientInfo &&
      activeClientInfo.map((info, key) => {
        return (
          <tr key={key}>
            <td>
              <a
                href="/client-dashboard"
                onClick={() => {
                  goToClientDashboard(info.clientCode, "");
                  // Navigate("/client-dashboard");
                  getTabStatus("")
                }}
              >
                {checkEmpty(info.clientCode) ? "-" : info.clientCode}
              </a>
            </td>
            {/* <td>{checkEmpty(info.margin) ? "-" : info.margin}</td> */}
            <td>{checkEmpty(info.clientName) ? "-" : info.clientName}</td>

            <td>
              {checkEmpty(info.ytdBrokerage)
                ? "-"
                : numDifferentiation(info.ytdBrokerage)}
            </td>
            {/* <td>{checkEmpty(info.pastAvg) ? "-" : info.pastAvg}</td> */}
            <td>
              <span
                className={
                  info.pnl == 0
                    ? "text-muted"
                    : info.pnl < 0
                    ? "red-txt"
                    : "green-txt"
                }
              >
                {checkEmpty(info.pnl) ? "-" : numDifferentiation(info.pnl)}
              </span>
            </td>
            {/* <td>
              {checkEmpty(info.lifetimeBrokerage)
                ? "-"
                : numDifferentiation(info.lifetimeBrokerage)}
            </td> */}
            <td>
              {checkEmpty(info.prevYrBrokerage)
                ? "-"
                : numDifferentiation(info.prevYrBrokerage)}
            </td>
          </tr>
        );
      })
    );
  };

  // console.log(activeClientInfo, "activeClientInfo");
  

  return (
    <div className="card-box activeclient">
      <div className="card-title">
        <div className="figure-inlac">
          <h2>{Constants.Top_Active_Clients}</h2>
          {/* <p>{Constants.Figure_In_Lacs_for_all}</p> */}
        </div>
        {activeClientInfo && activeClientInfo.length > 0 ? (
          <div className="view-more-wrapper">
            <button className="view-more" onClick={handleViewClick}>
              {Constants.View_All}
            </button>
          </div>
        ) : (
          ""
        )}
        <div className="card-right">
          {/* <DropdownFilter /> */}
          {/* <Form.Select size="lg" aria-label="Default select example" onChange={handleOnChange}>
            <option value="monthly">Monthly</option>
            <option value="quarterly">Quaterly</option>
            <option value="yearly">Yearly</option>
          </Form.Select> */}
        </div>
      </div>
      <div className="scroll-table active-table">
        {loader ? (
          <div className="loader-alignment">
            <Loader />
          </div>
        ) : activeClientInfo && activeClientInfo.length > 0 ? (
          <table className="table">
            <thead>
              <tr>
                <th>{Constants.Client_ID}</th>
                {/* <th>{Constants.Margin_Txt}</th> */}
                <th>Client Name</th>
                <th>{Constants.YTD_Brokerage}</th>
                <th>Previous Year Brokerage</th>
                {/* <th>{Constants.Lifetime_Income}</th> */}
              </tr>
            </thead>

            <tbody>{showActiveData(activeClientInfo)}</tbody>
          </table>
        ) : serverError === "Something went wrong, Please try again later." ? (
          <h4 className="no-data">{serverError}</h4>
        ) : (
          noDataFound()
        )}
      </div>

      <Modal
        show={showModal}
        // onHide={() => setShowModal(false)
        // }
        onHide={onHide}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="inactive-modal setting-model"
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header className="mb-4 modal-header">
          <Modal.Title id="contained-modal-title-vcenter modal-title">
            <div className="figure-inlac">
              <h2 className="h2-css-all">{Constants.Top_Active_Clients}</h2>
              {/* <p>{Constants.Figure_In_Lacs_for_all}</p> */}
            </div>
          </Modal.Title>
          <button
            type="button"
            className="btn-close"
            aria-label="Close"
            onClick={onHide}
          >
            <span className="icon-close"></span>
          </button>
        </Modal.Header>
        <Modal.Body>
          <div className="table-responsive scroll-table model-top-active-table align-section">
            <table className="table">
              <thead>
                <tr>
                  <th>{Constants.Client_ID}</th>
                  <th>Client Name</th>
                  {/* <th>{Constants.Margin_Txt}</th> */}
                  <th>{Constants.YTD_Brokerage}</th>
                  {/* <th>{Constants.Past_Average}</th> */}
                  <th>{Constants.Overall_PnL}</th>
                  <th>Previous Year Brokerage</th>
                  {/* <th>{Constants.Lifetime_Income}</th> */}
                </tr>
              </thead>

              <tbody id="abcd1" onScroll={handleScroll}>
                {showModalActiveData(activeClientInfo)}
                {scrollLoader && (
                  <div className="loader-center">
                    <LoaderForSearch />
                  </div>
                )}
              </tbody>
            </table>
          </div>
          <div className="generate-btn-wrapper">
            <button
              className="generate-btn text-green"
              value="excel"
              onClick={handleFileType}
            >
              {smallLoaderExcel ? (
                <SmallLoader />
              ) : (
                <>
                  <span className="icon-excelsvg"></span>
                  {"Excel"}
                </>
              )}
            </button>
            <button
              className="generate-btn txt-purple"
              onClick={handleFileType}
              value="pdf"
            >
              {smallLoaderPdf ? (
                <SmallLoader />
              ) : (
                <>
                  <span className="icon-pdfsvg"></span> {"PDF"}
                </>
              )}
            </button>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
}
export default TopActiveClientTable;
